export function formatCourseDuration(seconds: number) {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  if (hours > 0) {
    return minutes > 0 ? `${hours} hr ${minutes} min` : `${hours} hr`
  }

  return `${minutes} min`
}

export function formatDuration(num: number) {
  const minutes = Math.floor(num / 60)
  const seconds = num % 60

  return `${minutes}`.padStart(1, '0') + ':' + `${seconds}`.padStart(2, '0')
}

export function formatDurationISO8601(num: number) {
  const minutes = Math.floor(num / 60)
  const seconds = num % 60

  return `PT${minutes}M${seconds}S`
}
